import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UserService} from './services/user/user.service';
import {isStudent, isTeacher} from './cognito-user-interfaces';
import {UserDto} from '@api/utisha-backend';
import {ThemingService} from './services/theming/theming.service';
import {SidenavService} from './services/sidenav.service';
import {NgcCookieConsentService, NgcNoCookieLawEvent, NgcStatusChangeEvent} from 'ngx-cookieconsent';
import {Subscription} from 'rxjs';
import {SwUpdate} from '@angular/service-worker';
import {ActivatedRoute} from '@angular/router';
import {LanguageService} from './services/language.service';
import {WebPushService} from './services/web-push-service';
import {TrackingService} from './services/tracking.service';
import {logUtishaInfo} from './util/log';
import { NgClass } from '@angular/common';
import { HomeComponent } from './home/home.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NgClass, HomeComponent]
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'aws-amplify-cognito-authentication';
  user: UserDto;
  awsSignUpConfig = {
    defaultCountryCode: 'nl',
    signUpFields: []
  };
  theming: ThemingService;
  @ViewChild('snav') sidenavCmpt: { toggle: () => void } | undefined;

  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;

  constructor(private userService: UserService,
              private trackingService: TrackingService,
              private webpushService: WebPushService,
              private languageService: LanguageService,
              private sidenav: SidenavService,
              private route: ActivatedRoute,
              private ccService: NgcCookieConsentService,
              private updates: SwUpdate,
              theming: ThemingService) {
    this.languageService.loadLanguage();
    route.queryParams.subscribe((params) => {
      if (params.lang) {
        this.languageService.language = params.lang;
      }
    });
    this.userService.getUserObservable().subscribe({next: (user: UserDto | undefined) => this.user = user || {} as UserDto});
    this.theming = theming;
    sidenav.toggleEvents().subscribe(() => this.sidenavCmpt?.toggle());
    if (this.updates.isEnabled) {

      this.updates.versionUpdates.subscribe((ev) => {
        if (ev.type === 'VERSION_READY') {
          logUtishaInfo('version ready');
          window.location.reload();
        }
        // if (confirm('New version available. Load New Version?')) {
        //   window.location.reload();
        // }
      });
    }
    webpushService.listenToNotificationClicks();
  }

  isTeacher(): boolean {
    return isTeacher(this.user);
  }

  isStudent(): boolean {
    return isStudent(this.user);
  }

  isNotLoggedIn(): boolean {
    return this.user === undefined;
  }

  ngOnInit(): void {
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // you can use this.ccService.getConfig() to do stuff...
      });

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        // you can use this.ccService.getConfig() to do stuff...
      });
  }

  ngOnDestroy(): void {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }



}
